import { useCallback } from 'react';

import type { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';

export const useRemoveMarketFilterChipEvent = () => {
  const track = useEvents();
  const trackRemoveMarketFilterChip = useCallback(
    (attribute: string, value: string, sport: Sport) => {
      const params = {
        filterName: attribute,
        filterValue: value,
        sport,
      };
      track('Remove Market Filter Chip', params);
    },
    [track]
  );
  return trackRemoveMarketFilterChip;
};
